import { render } from "./CommissionFormAdmin.vue?vue&type=template&id=3fc10424"
import script from "./CommissionFormAdmin.vue?vue&type=script&lang=js"
export * from "./CommissionFormAdmin.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommissionFormAdmin.vue?vue&type=style&index=0&id=3fc10424&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__